import { Controller } from "@hotwired/stimulus";

export default class ShareController extends Controller {
  static targets = ["button"];

  share() {
    const url = window.location.href;

    navigator.clipboard.writeText(url).then(() => {
      this.showShared();
    });
  }

  showShared() {
    const originalHTML = this.buttonTarget.innerHTML;

    // Show checkmark and "Shared!" text
    this.buttonTarget.innerHTML = `
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <span>Link copied!</span>
    `;

    // Revert after 2 seconds
    setTimeout(() => {
      this.buttonTarget.innerHTML = originalHTML;
    }, 2000);
  }
}
